import * as R from 'fp-ts/Record';
import * as A from 'fp-ts/Array';
import * as F from 'fp-ts/Function';
import { machine_alphabet } from "./machine";
import { initialMachineStateAmpelSystem, initialMachineStateCodeschloss, initialMachineStateDoorSystem, initialMachineStateGaragentor, initialMachineStateKunstautomat1, initialMachineStateKunstautomat2 } from "./machineState";
import { MealyModelType } from '../mealyModels/mealyModelType';
const initialDialogState = {
    newProject: {
        isOpen: false,
    }
};
export const initialState = {
    // machineState: initialMachineStateMealy,
    machineState: initialMachineStateKunstautomat2,
    // machineState: initialMachineStateGaragentor,
    dialogState: initialDialogState,
    fullscreen: false,
};
export function getInitialMachineState(system) {
    if (system === MealyModelType.KUNSTAUTOMAT1) {
        return initialMachineStateKunstautomat1;
    }
    else if (system === MealyModelType.KUNSTAUTOMAT2) {
        return initialMachineStateKunstautomat2;
    }
    else if (system === MealyModelType.GARAGENTOR) {
        return initialMachineStateGaragentor;
    }
    else if (system === MealyModelType.AMPELSYSTEM) {
        return initialMachineStateAmpelSystem;
    }
    else if (system === MealyModelType.CODESCHLOSS) {
        return initialMachineStateCodeschloss;
    }
    else if (system === MealyModelType.DOORSYSTEM) {
        return initialMachineStateDoorSystem;
    }
    else {
        return initialMachineStateDoorSystem;
    }
}
// TODO: folgende Funktionen verschieben?
function machine_executeSingleChar(machine, input, previusExecutionState) {
    const inputPosition = previusExecutionState.inputPosition;
    let currentChar = input.charAt(inputPosition);
    let transition = Object.values(machine.transitions)
        .filter(transition => transition.fromStateId === previusExecutionState.currentNodeId)
        .filter(transition => transition.chars.includes(currentChar))[0];
    if (transition === undefined) {
        // keine Transition gefunden
        // TODO: Fehlerbehandlung?
        return previusExecutionState;
    }
    else {
        // Transition gefunden
        return {
            currentNodeId: transition.toStateId,
            inputPosition: inputPosition + 1,
        };
    }
}
function transitions_containChar(transitions, char) {
    for (let transition of Object.values(transitions)) {
        if (transition.chars.includes(char)) {
            return true;
        }
    }
    return false;
}
const node_missingTransitions = (machine) => (machineState) => {
    const transitions = R.filter((transition) => transition.fromNodeId === machineState.id)(machine.transitions);
    const chars = F.pipe((machine_alphabet(machine)), A.filter((char) => !transitions_containChar(transitions, char)));
    return ({
        fromMachineStateId: machineState.id,
        chars: chars,
    });
};
export function machine_missingTransitions(machine) {
    return F.pipe(machine.nodes, R.toArray, A.map(val => val[1]), A.map(node => node_missingTransitions(machine)(node)), A.filter(val => val.chars.length > 0));
}
function last(array) {
    return array[array.length - 1];
}
export function execute(machine, eingabe) {
    let currentNodeId = Object.values(machine.nodes).find(state => state.isStart).id;
    let executionStates = [{
            currentNodeId: currentNodeId,
            inputPosition: 0,
        }];
    let inputPosition = 0;
    while (inputPosition < eingabe.length) {
        let currentExecutionState = last(executionStates);
        let nextExecutionState = machine_executeSingleChar(machine, eingabe, currentExecutionState);
        executionStates.push(nextExecutionState);
        inputPosition = nextExecutionState.inputPosition;
    }
    // Eingabe komplett verarbeitet
    let currentMachineState = machine.nodes[last(executionStates).currentNodeId];
    const isAccepted = currentMachineState.isFinal;
    return {
        input: eingabe,
        executionStates: executionStates,
        isAccepted: isAccepted,
    };
}
